import React from "react";
import "./InvoiceBalancing.css";
import {
  CheckCircleFilled,
  ArrowRightOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
  CloudOutlined,
  RocketOutlined,
  CheckOutlined,
  ThunderboltFilled,
  DollarOutlined,
  BankOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import invoiceImage from "../../Asset/invoice-balancing.png";

const featuresLeft = [
  "Create and Manage Invoices",
  "Auto Invoice Numbering",
  "Multiple Client Management",
  "GST & Tax Calculation",
  "Payment Tracking",
  "Due & Pending Invoice Alerts",
  "Credit and Debit Notes",
  "Partial Payment Handling",
  "Balance Sheet Generation",
  "Daily Transaction Records",
];

const featuresRight = [
  "Accounts Ledger Management",
  "Bank Reconciliation",
  "Email & SMS Invoice Sharing",
  "Recurring Invoice Setup",
  "Multi-Currency Support",
  "User Role Management",
  "Expense Management",
  "Profit & Loss Reports",
  "Backup & Data Security",
  "Comprehensive Financial Reports",
];

const highlights = [
  {
    icon: <DollarOutlined />,
    title: "Smart Billing",
    desc: "Automated invoice generation",
  },
  {
    icon: <BankOutlined />,
    title: "Payment Tracking",
    desc: "Real-time payment monitoring",
  },
  {
    icon: <BarChartOutlined />,
    title: "Financial Reports",
    desc: "Detailed insights & analytics",
  },
];

const InvoiceBalancing = () => {
  const handleViewMore = () => {
    window.open("/invoice-details", "_blank");
  };

  return (
    <div className="ibs-page-light">
      {/* Decorative Background */}
      <div className="ibs-bg-grid"></div>
      <div className="ibs-glow-1"></div>
      <div className="ibs-glow-2"></div>

      <div className="ibs-container">
        
        {/* ═══════ PROFESSIONAL HEADER ═══════ */}
        <div className="ibs-header-new">
          <div className="ibs-header-top">
            <span className="ibs-badge">
              <span className="ibs-badge-dot"></span>
              FINTECH PRODUCT
            </span>
            <span className="ibs-version-tag">
              <ThunderboltFilled /> Version 2.5
            </span>
          </div>

          <div className="ibs-header-main">
            <div className="ibs-header-icon-box">
              <FileTextOutlined />
            </div>
            <div className="ibs-header-text">
              <h1 className="ibs-title-new">
                Invoice Balancing <span className="ibs-gradient-text">Application</span>
              </h1>
              <p className="ibs-subtitle-new">
                A powerful financial management platform designed to automate billing, 
                track payments, balance accounts, and generate comprehensive reports 
                for businesses of every scale with unmatched accuracy.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="ibs-meta-pills">
            <span className="ibs-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="ibs-meta-pill">
              <SafetyCertificateOutlined /> GST Compliant
            </span>
            <span className="ibs-meta-pill">
              <CloudOutlined /> Cloud-Based Software
            </span>
            <span className="ibs-meta-pill">
              <RocketOutlined /> 24/7 Support Included
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="ibs-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="ibs-left-col">
            <div className="ibs-image-wrapper">
              <div className="ibs-image-glow"></div>
              <img
                src={invoiceImage}
                alt="Invoice Balancing Application"
                className="ibs-image"
              />
              <div className="ibs-image-badge">
                <FileTextOutlined /> Billing Dashboard
              </div>
            </div>

            {/* Highlights Row */}
            <div className="ibs-highlights">
              {highlights.map((item, index) => (
                <div className="ibs-highlight-card" key={index}>
                  <div className="ibs-highlight-icon">{item.icon}</div>
                  <div className="ibs-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="ibs-right-col">
            <div className="ibs-info-block">
              <p className="ibs-para">
                The <strong>Invoice Balancing Application</strong> is a powerful 
                financial tool designed to help businesses manage, track, and balance 
                their invoices with complete accuracy. It automates the billing process 
                and eliminates manual errors in day-to-day accounting operations.
              </p>

              <p className="ibs-para">
                This application ensures seamless <strong>invoice management, payment 
                tracking, and account balancing</strong> — all in one unified platform. 
                Perfectly suited for small businesses, growing enterprises, and 
                accounting professionals who demand efficient control over their finances.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="ibs-features-section">
              <h2 className="ibs-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="ibs-features-desc">
                Discover our comprehensive suite of powerful features designed to 
                streamline your financial management operations.
              </p>

              <div className="ibs-features-grid">
                <ul className="ibs-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="ibs-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="ibs-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="ibs-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="ibs-cta-wrap">
              <button className="ibs-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="ibs-cta-note">
                💡 Get a live demo and pricing consultation
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceBalancing;